import * as en from './en.json';
import * as es from './es.json';
import * as fr from './fr.json';
import * as pt from './pt.json';

export const locales = {
  en: (en as any).default,
  es: (es as any).default,
  fr: (fr as any).default,
  pt: (pt as any).default
};
